import Core from '@plugin_newsletter/core';
import NewsletterView from '@plugin_newsletter/components/index';

const NewsletterDefault = (props) => <Core NewsletterView={NewsletterView} {...props} />;

export default NewsletterDefault;
